/**
 * Home template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

import { Buffer } from 'buffer';

if (typeof window !== 'undefined' && !window.Buffer) {
	window.Buffer = Buffer;
}

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Custom';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * Hide Klaviyo overlay when mobile menu opens (conflicts with drawer).
 * Lives here (not theme.liquid) to avoid inline scripts in the layout.
 * Selector (.kl-private-reset-css-Xuajs1) is Klaviyo-generated — update if their embed DOM changes.
 * After editing: run `npm run build` in static/ to rebuild assets/custom.js.
 */
const initKlaviyoMenuHide = () => {
	const menuButton = document.querySelector('[data-js-menu-button]');
	if (!menuButton) return;

	menuButton.addEventListener('click', () => {
		const klaviyoOverlay = document.querySelector('body > div > .kl-private-reset-css-Xuajs1');
		if (klaviyoOverlay) {
			klaviyoOverlay.style.display = 'none';
		}
	});
};

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.info(`${NAME} > loaded`);
	initKlaviyoMenuHide();
};

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
